import React, { memo, useMemo, useState } from 'react';
import { Fade, Tooltip } from '@mui/material';
import { getHintClusterBaloonPos } from './baloonDimensionService';

const ClusterMarkerPopup = memo(({
  isMobile,
  id,
  toggleZoom,
  onTouchStart,
  $geoService,
  $getDimensions,
  $dimensionKey,
  containerStyles,
  children,
  pointsData,
}) => {
  const [isPopoverOpen, setPopoverOpen] = useState(false);

  const hintBaloonPos = useMemo(() => {
    const mapWidth = $geoService.getWidth();
    const markerDim = $getDimensions($dimensionKey);

    return getHintClusterBaloonPos(200, 260, markerDim.x, markerDim.y, mapWidth);
  }, [$getDimensions, $dimensionKey, $geoService]);

  const handleTouchStart = isMobile ? () => onTouchStart(id) : null;
  const handleMouseEnter = isMobile ? null : (event) => {
    toggleZoom(false);
    setPopoverOpen(true);
  };

  const handleRequestClose = () => {
    toggleZoom(true);
    setPopoverOpen(false);
  };

  return (
    <Tooltip
      open={isPopoverOpen}
      onClose={handleRequestClose}
      disableHoverListener={isMobile}
      TransitionComponent={Fade}
      placement={hintBaloonPos}
      slotProps={{
        tooltip: {
          style: {
            padding: '8px 10px',
          }
        },
        popper: {
          style: {
            boxShadow: 'none',
          },
        }
      }}
      arrow
      title={(
        <div className="i2p2-marker-content i2p2-cluster">
          <div className="container">
            <div className="circle yellow" />
            <span>
              <strong>{pointsData.alert}</strong>
                &nbsp; Alert
            </span>
          </div>
          <div className="container">
            <div className="circle green" />
            <span>
              <strong>{pointsData.available}</strong>
                &nbsp; Available
            </span>
          </div>
          <div className="container">
            <div className="circle blue" />
            <span>
              <strong>{pointsData.monitored}</strong>
                &nbsp; Monitored
            </span>
          </div>
          <div className="container">
            <div className="circle red" />
            <span>
              <strong>{pointsData.partially_oos}</strong>
                &nbsp; Partially out of service
            </span>
          </div>
          <div className="container">
            <div className="circle black" />
            <span>
              <strong>{pointsData.totally_oos}</strong>
                &nbsp; Totally out of service
            </span>
          </div>
          <div className="container">
            <div className="circle gray" />
            <span>
              <strong>{pointsData.unknown}</strong>
                &nbsp; Unknown
            </span>
          </div>
        </div>
      )}
    >
      <div
        onTouchStart={handleTouchStart}
        onMouseEnter={handleMouseEnter}
        style={containerStyles}
        className="i2p2-marker"
      >
        {children}
      </div>
    </Tooltip>
  );
});

export default ClusterMarkerPopup;
